<template>
  <article>
    <v-fab-transition>
      <v-btn
        v-if="showTopBtn"
        color="primary"
        :style="topStyle"
        dark
        fixed
        right
        fab
        @click="scrollToTop"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        v-if="showBottomBtn"
        color="primary"
        :style="bottomStyle"
        dark
        fixed
        bottom
        right
        fab
        @click="scrollToBottom"
      >
        <v-icon>mdi-arrow-down</v-icon>
      </v-btn>
    </v-fab-transition>
  </article>
</template>

<script lang="js">
  import { mapState } from 'vuex'
  import { CHAT_BUTTON } from '@/components/support/config'

  // Vuetify ставит fixed fab на 16 px от края; «вверх» - на 69 px выше «вниз».
  const EDGE = 16
  const STEP = 69
  // Зазор между кнопкой чата поддержки и кнопкой «вниз» над ней.
  const GAP = 12

  export default {
    name: 'FloatingButtons',
    data () {
      return {
        showTopBtn: false,
        showBottomBtn: false,
        interval: null,
        resizeObserver: null,
      }
    },
    computed: {
      ...mapState({ chatVisible: state => state.support.chatButtonVisible }),
      // Есть кнопка чата FAKT Support - встаём над ней и по её правому краю, иначе как раньше.
      base () {
        return this.chatVisible
          ? { bottom: CHAT_BUTTON.offset + CHAT_BUTTON.size + GAP, right: CHAT_BUTTON.offset }
          : { bottom: EDGE, right: EDGE }
      },
      bottomStyle () {
        return { bottom: `${this.base.bottom}px`, right: `${this.base.right}px` }
      },
      topStyle () {
        return { bottom: `${this.base.bottom + STEP}px`, right: `${this.base.right}px` }
      },
    },
    created () {
      window.addEventListener('scroll', this.handleScroll)
    },
    mounted () {
      this.resizeObserver = new ResizeObserver(this.handleResize)
      this.resizeObserver.observe(document.body)
    },
    unmounted () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      this.resizeObserver.unobserve(document.body)
    },
    methods: {
      handleResize () {
        this.showBottomBtn = document.body.scrollHeight > window.innerHeight
      },
      handleScroll () {
        this.showTopBtn = window.scrollY > 200
        this.showBottomBtn = document.body.scrollHeight > window.innerHeight && document.body.scrollHeight !== window.innerHeight + window.scrollY
      },
      scrollToTop () {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      scrollToBottom () {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
      },
    },
  }
</script>
